function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Mask",
  d: "M14.9936 13.9137C15.4021 14.3222 15.4021 14.9351 14.9936 15.3437C14.7893 15.548 14.585 15.6501 14.2786 15.6501C13.9721 15.6501 13.7679 15.548 13.5636 15.3437L8.15 9.9301L2.73643 15.3437C2.53214 15.548 2.32786 15.6501 2.02143 15.6501C1.715 15.6501 1.51071 15.548 1.30643 15.3437C0.897857 14.9351 0.897857 14.3222 1.30643 13.9137L6.72 8.5001L1.30643 3.08653C0.897857 2.67795 0.897857 2.0651 1.30643 1.65653C1.715 1.24795 2.32786 1.24795 2.73643 1.65653L8.15 7.0701L13.5636 1.65653C13.9721 1.24795 14.585 1.24795 14.9936 1.65653C15.4021 2.0651 15.4021 2.67795 14.9936 3.08653L9.58 8.5001L14.9936 13.9137Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.715
});

function SvgToastClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastClose);
export default __webpack_public_path__ + "static/media/ToastClose.8db29e3694d431867d05986831aa64a8.svg";
export { ForwardRef as ReactComponent };